/**
 * Scroll to element upon clicking anchored hyperlink (requires utilities/scroll-to-target.js)
*/

import EventBus from './../event-bus.js'
import './../utilities/scroll-to-target.js'
import jQuery from 'jquery'

const AnchorScroll = {
    
    init() {

        jQuery(document).on('click', 'a[href^="#"]', (event) => {
            
            let clicked = jQuery(event.currentTarget);

            //Ignore empty anchors
            let targetSel = clicked.attr('href')
            let anchorClasses = clicked.attr('class')

            if (targetSel == '#' || typeof anchorClasses != 'undefined' && anchorClasses.match(/carousel-control-(?:prev|next)/)) {
                event.preventDefault()
                return
            }
            
            //Ignore bootstrap toggles
            if (clicked.data('toggle') || clicked.data('no-scroll')) {
                return
            }
            
            let target = jQuery(targetSel)
            if (target.length === 0) {
                return
            }
            
            var options = {
                target: target,
                offset: 0
            }
            
            //Offset by header height
            let header = clicked.data('header')

            if (!header && jQuery('header').length === 1) {
                header = jQuery('header')
            }

            if (header) {
                options.offset += jQuery(header).outerHeight()
            }
            
            //Offset by data attribute
            let offset = clicked.data('offset')
            if (offset) {
                options.offset += offset
            }

            if (jQuery('body').hasClass('logged-in') && jQuery('#wpadminbar').length > 0) {
                let marginTop = parseInt(jQuery('html').css('margin-top').replace('px', ''))
                options.offset += marginTop
            }
            
            event.preventDefault()
            EventBus.publish('scroll-to-target', options)
            
        })
        
    }
    
}

EventBus.subscribe('init-modules', AnchorScroll.init)

export default AnchorScroll
